/*
 * Exports React proptype validator for moment objects.
 *
 * For reference, see: https://facebook.github.io/react/docs/reusable-components.html. To use: see DeadlineMessage.jsx
 *
<code>
var momentReactValidator = require('js/lib/moment.validator');
...
   propTypes: {
      date: momentReactValidator
      requiredDate: momentReactValidator.isRequired
  }
</code>
 * @author dwinegar@coursera.org
 */

/* eslint-disable no-var */
import moment from 'moment';

var ReactPropTypeValidator;

if (moment.isMoment && !moment.ReactPropTypeValidator) {
  ReactPropTypeValidator = function (props, propName, componentName) {
    if (props[propName] !== undefined && props[propName] !== null) {
      return ReactPropTypeValidator.isRequired(props, propName, componentName);
    }

    return null;
  };

  ReactPropTypeValidator.isRequired = function (props, propName, componentName) {
    if (!moment.isMoment(props[propName])) {
      // custom validators must return an error, not throw it
      return new Error(`Prop '${propName}' in component '${componentName}' is not of type 'moment'.`);
    }

    return null;
  };
}

export default ReactPropTypeValidator;
